// extracted by mini-css-extract-plugin
export default {"bgc":"AddBooks_bgc__rC5LF","title":"AddBooks_title__TWYXW","wrapper":"AddBooks_wrapper__gfv3-","back":"AddBooks_back__EH2jJ"};